import { DollarSign } from 'lucide-react';
import { formatMetaCurrency } from '@/utils/currency';
import { AdAccountHealth } from '@/services/facebook-ad-account.service';

interface Props { health: AdAccountHealth | null; }

export const AdSpendCard: React.FC<Props> = ({ health }) => {
  const currency = health?.currency ?? '';
  const spent = formatMetaCurrency(health?.amountSpent, currency);
  const balance = formatMetaCurrency(health?.balance, currency);
  const cap = health?.spendCap === undefined ? '—' : Number(health.spendCap) === 0 ? 'Unlimited' : formatMetaCurrency(health.spendCap, currency);
  const remaining = Number(health?.spendCap) > 0 && health?.amountSpent !== undefined
    ? formatMetaCurrency(String(Math.max(0, Number(health.spendCap) - Number(health.amountSpent))), currency)
    : '—';

  return (
    <div className="bg-surface border border-border rounded-lg p-5">
      <div className="flex items-center gap-2 mb-3">
        <DollarSign size={16} className="text-primary" />
        <h3 className="text-sm font-semibold text-text-primary">Spend &amp; Balance</h3>
        <span className="text-xs text-text-muted ml-auto">{currency}</span>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="text-[10px] uppercase tracking-wide text-text-muted">Spent</div>
          <div className="text-2xl font-bold text-text-primary mt-1">{spent}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wide text-text-muted">Amount due</div>
          <div className="text-2xl font-bold text-text-primary mt-1">{balance}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wide text-text-muted">Remaining spend cap</div>
          <div className="text-lg font-semibold text-text-primary mt-1">{remaining}</div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wide text-text-muted">Spend cap</div>
          <div className="text-lg font-semibold text-text-primary mt-1">{cap}</div>
        </div>
      </div>
    </div>
  );
};
